import React from 'react';
import { ToastContainer } from 'react-toastify';
import * as Sentry from '@sentry/react';

import HomeRoutes from './components/Routes/HomeRoutes';
import ErrorFallback from './components/ErrorFallback/ErrorFallback';

const App = () => {
  return (
    <Sentry.ErrorBoundary fallback={({ resetError }) => <ErrorFallback resetError={resetError} />}>
      <HomeRoutes />
      <ToastContainer position="top-right" autoClose={4000} />
    </Sentry.ErrorBoundary>
  );
};

export default App;
